import { Header } from "../components/global/header/Header";
import { Footer } from "../components/global/footer/Footer";

export default function Gallery(): JSX.Element {
  return (
    <>
      <Header />
      <div className="flex flex-col items-center justify-center min-h-screen">
      </div>
      <Footer />
    </>
  );
} 